import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  useUnreadNotificationCount,
  useNotificationRealtime,
} from "@/hooks/useNotifications";
import { useNotificationPanel } from "./NotificationPanelContext";

export function NotificationBell() {
  useNotificationRealtime();
  const { open, toggle } = useNotificationPanel();
  const { data: unreadCount = 0 } = useUnreadNotificationCount();

  const display = unreadCount > 99 ? "99+" : String(unreadCount);

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative"
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ""}`}
      aria-pressed={open}
      onClick={toggle}
    >
      <Bell className="h-5 w-5" />
      {unreadCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-semibold flex items-center justify-center leading-none">
          {display}
        </span>
      )}
    </Button>
  );
}